<template>
  <div v-if="!isUndefined(updateSearchQuery)" class="flex-wrap items-center justify-between" style="float: right">
    <input class="search" v-model="searchQuery" placeholder="Buscar..."/>
  </div>
</template>

<script>
export default {
  data(){ return {
    searchQuery: '',
    };
  },
  watch: {
    searchQuery: function() {
      this.$emit('updateSearchQuery', this.searchQuery);
    },
  }
}
</script>

<!-- - - - - - - - - - - - - - - - STYLE - - - - - - - - - - - - - - - -->
<style lang="css" scoped>
  .search {
    float: right;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: white;
    height: 50px;
    width: 200px;
    border-radius: 100px;
    padding: 0 15px;
    margin-left: 15px;
  }
</style>
